import actions from './actions/actions'
import mutations from './mutations/mutation'
const state = {
  userInfo: {
    membercode: '',
    mlevelname: '',
    memberid: '',
    hpurl: '',
    nickname: '',
    realname: '',
    birthday: '',
    sex: '',
    mlevelcode: '',
    imore: '',
    freticketnum: '',
    openshare: '',
    username: '',
    mdiscount: '',
    mphone: '',
    email: '',
    cbalance: '',
    ibalance: '',
    emailcheck: '',
    mphonecheck: ''
  },
   userInfo1: '',
  checkedSlide: false,
  verifycode: '',
  forgetPasswordStep: 0,
  mphone: '',
  mphonecheck: false,
  emailcheck: false,
  checkErrorMessage: '',
  personalDetails: '',
  canPush: false,
  canIndexPush: false,
  qcodeurl: '',
  uniqcode: '',
  showQcodeUrl: false,
  showWxLoginSuccess: false,
  registering: '',
  registerings: '',
  registeringshow: false,
  login_user: ''
}

export default{
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/pages/GenRedOne/store/modules/login/login.js